import { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const useScrollRestoration = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const scrollPositions = useRef({}); // Store scroll positions for each route

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  // Debounce scroll movements (optional)
  const scrollToPosition = debounce((x, y) => {
    window.scrollTo(x, y);
  }, 50);

   useLayoutEffect(() => {
    // This effect runs on EVERY navigation

    const key = location.key || location.pathname;

    const handleRestoration = () => {
      // Restore scroll position for back/forward navigation
      if (navigationType === "POP") {
        const savedPosition = scrollPositions.current[key];
        if (savedPosition) {
          scrollToPosition(savedPosition.x, savedPosition.y);
        }
      } else {
        // Scroll to the top for new navigations (push/replace)
        window.scrollTo(0, 0);
      }
    };

    // Delay restoration to account for lazy-loaded components
    const timeout = setTimeout(() => {
      handleRestoration();
    }, 50);

    return () => {
      clearTimeout(timeout);
    };
  }, [location, navigationType, scrollToPosition]);

   useLayoutEffect(() => {
    // This effect runs whenever location changes, to save the old page's scroll
    const saveScrollPosition = () => {
      const key = location.key || location.pathname;
      scrollPositions.current[key] = {
        x: window.scrollX,
        y: window.scrollY,
      };

      // Limit the size of the scroll positions object
      const keys = Object.keys(scrollPositions.current);
      if (keys.length > 100) {
        delete scrollPositions.current[keys[0]];
      }
    };

    return () => {
      saveScrollPosition();
    };
  }, [location]);
};

export default useScrollRestoration; 
